export default __webpack_public_path__ + "static/media/said.aeec7df4.png";